import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  /*
  * 租赁管理
  * */
  tenancyManageList: {},
  tenancyManageMark: 0
  // searchFormInfo: {
  //   ref: null,
  //   data: {
  //     supplierCode: '',
  //     type: '',
  //     status: '',
  //     time: '',
  //     beginTime: '',
  //     endTime: ''
  //   },
  //   rules: {},
  //   labelWidth: '90px'
  // }
}

const actions = {
  /*
  * 租赁管理
  * */
  // 获取列表
  [types.LEASEGETPAGE] (context, params) {
    http.fetch('/api/lease/getPage', params).then(data => {
      context.commit(types.LEASEGETPAGE, data)
    })
  },
  // 新增
  [types.LEASEADD] (context, params) {
    http.fetch('/api/lease/add', params).then(data => {
      context.commit(types.LEASEADD, data)
    })
  },
  // 编辑
  [types.LEASEUPDATE] (context, params) {
    http.fetch('/api/lease/update', params).then(data => {
      context.commit(types.LEASEUPDATE, data)
    })
  },
  // 删除
  [types.LEASEDELETE] (context, params) {
    let type = params.status === 0 ? 'del' : ''
    http.fetch('/api/lease/delete', params).then(data => {
      context.commit(types.LEASEDELETE, {...data, type})
    })
  }
}

const mutations = {
  /*
  * 租赁管理
  * */
  // 获取列表
  [types.LEASEGETPAGE] (state, data) {
    state.tenancyManageList = data
  },
  // 新增
  [types.LEASEADD] (state, data) {
    if (data.code !== 200) return false
    state.tenancyManageMark = 1
    vue.$message({
      showClose: true,
      message: '新增成功',
      type: 'success'
    })
  },
  // 编辑
  [types.LEASEUPDATE] (state, data) {
    if (data.code !== 200) return false
    state.tenancyManageMark = 1
    vue.$message({
      showClose: true,
      message: '编辑成功',
      type: 'success'
    })
  },
  // 删除
  [types.LEASEDELETE] (state, data) {
    if (data.code !== 200) return false
    let message = data.type === 'del' ? '删除成功' : '已结束租赁'
    state.tenancyManageMark = 1
    vue.$message({
      showClose: true,
      message,
      type: 'success'
    })
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/tenancyManage/index.js